export default [{
  path: '/painel-oportunidades',
  name: 'painel-oportunidades',
  component: () => import('@/app-modulo/comercial/oportunidades/PainelOportunidades.vue'),
  meta: {
    resource: 'paineloportunidades',
    action: 'read',
    navActiveLink: 'painel-oportunidades',
    pageTitle: 'Jornada',
    useButtonFunil: true,
  },
  // children: [
  //   {
  //     path: '/painel-proposta/proposta/:id',
  //     component: () => import('@/app-modulo/comercial/cadastro-proposta/CadastroProposta.vue'),
  //     name: 'cadastro-proposta',
  //   },
  // ],
}]
